// WhatWeDo.js
import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Briefcase } from 'lucide-react';

const WhatWeDo = () => {
  const pathways = [
    {
      icon: GraduationCap,
      title: 'Study Abroad Support',
      description: 'We guide students through international education opportunities by providing consultation led support, application preparation, and ongoing guidance throughout the admissions process.',
      color: 'blue'
    },
    {
      icon: Briefcase,
      title: 'Work Abroad Support',
      description: 'We assist eligible candidates in accessing international employment opportunities through structured screening, interview preparation, and coordination with verified employer partners.',
      color: 'purple'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'border-t-blue-500',
      purple: 'border-t-purple-500'
    };
    return colors[color] || 'border-t-blue-500';
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
            What We Do
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-2xl mx-auto">
            Notapaths supports individuals across two primary pathways
          </p>
        </motion.div>

        {/* Pathways Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {pathways.map((pathway, index) => {
            const Icon = pathway.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`bg-white p-6 border-t-2 ${getColorClasses(pathway.color)} hover:shadow-lg transition-shadow`}
              >
                <Icon size={32} className="text-gray-700 mb-4" />
                
                <h3 className="text-lg font-semibold text-[#202356] mb-3 leading-tight">
                  {pathway.title}
                </h3>
                
                <p className="text-gray-600 text-sm font-light leading-relaxed">
                  {pathway.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
